class NavbarController {
  /* @ngInject */
  constructor($log, $rootScope, $state, endPoints, StorageService, MerchantProfileStore, StoreService, LoginService, NewTokenService, NewBackendService, Dispatcher, ImageUtilsService) {
    const that = this;
    var firstClick = true;

    /*const isSuperAdmin = () => {
      const userContext = NewTokenService.getUserContext();
      that.isSuperAdmin = userContext !== undefined ? userContext.superAdmin : false;
      that.showMenuButton = $state.current.name !== 'listaMerchantSuperAdmin';
    };*/

    that.closeSidenav = () => {
      if(firstClick){
        firstClick = false;
      }else{
        $rootScope.$broadcast('TOOGLE_SIDENAV', that.showMenuButton);
      }
    }

    that.selectProfile = p => {
      if (p === this.currentWallet) return;
      this.currentWallet = p.wallet.id;
      console.log("changed current wallet ", this.currentWallet);
    }

    that.close = () => {
      console.log("close");
      const cw = StorageService.getLocalStorageObject('currentWallet');
      if (cw == this.currentWallet) return; 

      console.log("changed");
      
      StorageService.clearLocalStorage("userContext");
      StorageService.clearLocalStorage("selectedStore");
      LoginService.switchToken(this.currentWallet).then(() => {
        
        StoreService.getStoreList().then(() => {
          $rootScope.$broadcast("$storeChangeSuccess");
          $state.go('dashboard');
          //Reload everything
          setTimeout(() => {
            window.location.reload();
          }, 200)
        })
      })
    }

    const isSuperAdmin = () => {
      this.isSuperAdmin = StorageService.getLocalStorage('superAdmin');
      that.showMenuButton = $state.current.name !== 'listaMerchantSuperAdmin';
    }

    const checkMultipleLR = () => {
      const isMultipleLR = MerchantProfileStore.isMultipleLR();
      if (isMultipleLR) {
        that.isMultipleLR = true;
        that.businesses = NewTokenService.getBusinesses();
        
        if (that.businesses) {
          that.businesses = that.businesses.filter(b => b.status === "ENABLED");
        }
        that.currentWallet = NewTokenService.getCurrentWallet();
      }
    }

    const getAvatar = (idMerchantAvatar) => {
    
      NewBackendService.invokeWebApiGet(`${endPoints.userUrl}/businesses/${idMerchantAvatar}/img/ba`, {}, false, 'arraybuffer').then(result => {  
          that.user.avatar = ImageUtilsService.byteArrayToUrl(result.data);
          StorageService.setLocalStorage("userContext", JSON.stringify(that.user));
      }, (error) => {
        $log.error(error);
      });
    };

    const init = () => {
      that.isLogged = NewTokenService.isLogged();
      isSuperAdmin();
      checkMultipleLR();
      if (that.isLogged ) {
        that.level = LoginService.getWalletLevelLabel();
        LoginService.getMerchantProfile(false).then((merchantProfile) => {
          that.user = merchantProfile;
          console.log(that.user)
          if (that.user.business.id) {
            getAvatar(that.user.business.id);
          }
          that.banner = that.user.lastName;
        });
      }
    };

    that.$onInit = init;

    that.logout = () => {
      if (that.isSuperAdmin && $state.current.name !== 'listaMerchantSuperAdmin') {
        StoreService.clean();
        $state.go('listaMerchantSuperAdmin');
        Dispatcher.dispatch({
          actionType: 'GLOBAL_CLEAN',
          data: undefined,
          state: 'STORE_EMPTY'
        });
      } else {
        LoginService.softLogout();
      }
    };

    const refreshAvatarOnChange = $rootScope.$on('AVATAR_CHANGE', (evt, data) => {
      that.user.avatar = data;
    });

    const refreshBannerOnChange = $rootScope.$on('BANNER_CHANGE', (evt, data) => {
      that.banner = data;
    });

    const deregLoginListener = $rootScope.$on('USER_LOGGED_IN', init);

    const deregLoginSuperAdminListener = $rootScope.$on('SUPER_ADMIN_LOGGED_IN', () => {
      that.isLogged = true;
    });

    const deregLoginSuperAdminUpgradeListener = $rootScope.$on('SUPER_ADMIN_UPGRADED', init);


    const deregLogoutListener = $rootScope.$on('USER_LOGGED_OUT', () => {
      that.user = undefined;
      that.isLogged = false;
    });

    const deregBusinessesChangedListener = $rootScope.$on('$businessesChangeSuccess', () => {
      checkMultipleLR();
    });

    const deregStateChangedListener = $rootScope.$on('$stateChangeSuccess', () => {
      isSuperAdmin();
    });

    that.$onDestroy = () => {
      deregLoginListener();
      deregLogoutListener();
      refreshAvatarOnChange();
      refreshBannerOnChange();
      deregStateChangedListener();
      deregLoginSuperAdminListener();
      deregBusinessesChangedListener();
    };
  }
}

export default NavbarController;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/navbar/navbar.controller.js
 **/